<template>
  <div class="white-bg common-container">
    <div class="wrap el-row-overflow">
      <h2 class="public-title">合作条件</h2>
      <el-row :gutter="24">
        <el-col :md="6" :sm="8" :xs="12" v-for="(item,index) in conditionCon" :key="index">
          <div class="condition-list">
            <p class="condition-tit">{{item.name}}</p>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script >
import { defineComponent, ref, reactive } from "vue";
export default defineComponent({
  setup() {
    const conditionCon = reactive([
      {
        name:
          "认可文都的发展思路和经营管理模式，认可文都推行的管理理念和文都相关项目的未来发展前景"
      },
      {
        name: "具备法人资格和营业许可证"
      },
      {
        name: "具有良好的商业信誉和人员素质，能合法经营"
      },
      {
        name: "对当地的培训市场有一定的了解，有一定的市场运作能力和财力条件"
      },
      {
        name: "最大努力的推动合作项目在当地的发展"
      },
      {
        name: "使用文都统一规定的课程"
      },
      {
        name: "接受和执行文都制定的统一的管理制度和办法，执行合约中规定的条款"
      }
    ]);
    return {
      conditionCon
    };
  }
});
</script>

<style lang="scss" scoped type="text/scss">
.condition-list {
  position: relative;
  width: 100%;
  height: 160px;
  background: url("../../assets/images/icon/bg_default.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 24px;
  .condition-tit {
    padding: 40px 40px 0;
    font-size: 16px;
  }

  &:hover {
    background: url("../../assets/images/icon/bg_hover.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
  }
}
</style>
